module.exports = __webpack_public_path__ + "media/images/anna-5346ebae03fd322a6e6abba8c214e0ec.png";